import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./ProductOnboardingForm.scss";
import StepperComponent from "../../Stepper/StepperComponent";
import OnboardProduct from "./OnboardProduct";
import DataProfiling from "../DataProfiling/DataProfiling";
import { useSelector, useDispatch } from "react-redux";
import {
  SET_STEP,
  INCREMENT_STEP,
  DECREMENT_STEP,
} from "../../../../redux/onboarding/onboarding.type";
import AssetSelectionModal from "../onBoardingAsset/AssetSelectionModal";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import DataQuality from "../Data Quality/DataQuality";
import PublishMain from "../Publish/PublishMain";
import heartLoading from "../../../../../src/assests/heartLoading.gif";
import { useAuth } from "../../../../context/AuthContext";

const ProductOnboardingForm = () => {
  const { authUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [phaseLoading, setPhaseLoading] = useState(!!useParams().id);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { currentStep } = useSelector((state) => state.onboarding);
  const [selectedTableIds, setSelectedTableIds] = useState("");
  const [currentPhase, setCurrentPhase] = useState("");
  const [apiAssetSources, setApiAssetSources] = useState([]);
  const [formData, setFormData] = useState({});
  const [userRole, setUserRole] = useState("");

  const selectionId = localStorage.getItem("selectionId");
  const assetSources = JSON.parse(localStorage.getItem("assetSource") || "[]");

  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  console.log("region", region);
  console.log("country", country);
  const [newCurentStep, setNewCurrentStep] = useState(currentStep);

  if (loading) {
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
      <div className="flex flex-col items-center space-y-3">
        <img src={heartLoading} alt="Loading..." className="h-30" />
        <span className="text-gray-700 text-[20px]">
          Hang tight! The resources are loading...
        </span>
      </div>
    </div>;
  }

  const getCurrentStatus = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/current-phase/${id}`
      );
      if (response.status === 200) {
        setCurrentPhase(response?.data?.current_phase);
        // setCurrentPhase("Column Selection")
      }
    } catch (e) {
      setLoading(false);
      console.error("getting error while fetching the currrent phase");
    } finally {
      setPhaseLoading(false);
    }
  };

  useEffect(() => {
    const fetchEditData = async () => {
      if (!id) return;
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/edit-form/${id}`
        );
        if (response.status === 200 && response.data) {
          const data = response.data;
          // Map API response to formData, skipping 'N/A' values
          setApiAssetSources(data?.assetSource);
          setFormData(data);
          setCountry(data?.marketCountry);
          setRegion(data?.marketRegion);
        }
      } catch (error) {
        toast.error("Failed to fetch product for editing");
      } finally {
        setLoading(false);
      }
    };
    fetchEditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (authUser){
      setUserRole(authUser.role);
    }
  }, [authUser]);

  useEffect(() => {
    if (!id) return;
    getCurrentStatus(id);
  }, [id]);

  console.log("corrunt Phase", currentPhase);

  useEffect(() => {
    if (currentPhase === "Product Onboarding") {
      setNewCurrentStep(0);
    } else if (
      currentPhase === "Data Asset Selection" ||
      currentPhase === "Column Selection"
    ) {
      setNewCurrentStep(1);
    } else if (currentPhase === "Profiling") {
      handleStep(2);
      setNewCurrentStep(2);
    } else if (currentPhase === "Data Quality Rule Configuration") {
      setNewCurrentStep(3);
    } else if (currentPhase === "Data Contract Publish") {
      setNewCurrentStep(4);
    } else {
      setNewCurrentStep(0);
    }
  }, [currentPhase]);

  console.log("selectionId, id ", id ? id : selectionId);

  // Process selectedSources for AssetSelectionModal
  const processedSelectedSources = Array.isArray(assetSources)
    ? assetSources
        .filter(
          (s) =>
            s && (typeof s === "string" || (typeof s === "object" && s.value))
        )
        .map((s) =>
          typeof s === "string" ? s.toLowerCase() : s.value.toLowerCase()
        )
    : [];

  console.log("processedSelectedSources:", processedSelectedSources);

  const handleStep = (step) => {
    dispatch({ type: SET_STEP, payload: step });
  };

  const handleNext = (tableIds) => {
    if (tableIds) {
      setSelectedTableIds(tableIds);
    }
    dispatch({ type: INCREMENT_STEP });
    setNewCurrentStep((value) => value + 1);
  };

  const handlePrevious = () => {
    dispatch({ type: DECREMENT_STEP });
    setNewCurrentStep((value) => value - 1);
  };

  const handleNextFromAsset = () => {
    dispatch({ type: INCREMENT_STEP });
  };

  // Show beautiful centered loading spinner while phaseLoading is true
  if (phaseLoading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..." className="h-30" />
          <span className="text-gray-700 text-[20px]">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }

  return (
    <>
      {setNewCurrentStep === null && (
        <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
          <div className="flex flex-col items-center space-y-3">
            <img src={heartLoading} alt="Loading..." className="h-30" />
            <span className="text-gray-700 text-[20px]">
              Hang tight! The resources are loading...
            </span>
          </div>
        </div>
      )}
      {newCurentStep === 0 && (
        <>
          <div className="flex justify-end items-center gap-2 font-bold">
            <span className="text-md text-gray-500">Version#:</span>
            
            {formData?.version || 2}
          </div>
          <StepperComponent step={newCurentStep} />
          <OnboardProduct
            userRole={userRole}
            handleStep={handleStep}
            onNext={handleNext}
          />
        </>
      )}
      {newCurentStep === 1 && (
        <>
          <StepperComponent step={newCurentStep} />
          <AssetSelectionModal
            id={id ? id : selectionId}
            nextStep={handleNext}
            previousStep={handlePrevious}
            selectedSources={
              processedSelectedSources.length > 0
                ? processedSelectedSources
                : apiAssetSources
            }
            region={region}
            country={country}
            columnScreen={currentPhase === "Column Selection" ? true : false}
          />
        </>
      )}
      {newCurentStep === 2 && (
        <>
          <StepperComponent step={newCurentStep} />
          <DataProfiling
            onPrevious={handlePrevious}
            nextStep={handleNext}
            id={id ? id : selectionId}
          />
        </>
      )}

      {newCurentStep === 3 && (
        <>
          <StepperComponent step={newCurentStep} />
          <DataQuality
            onPrevious={handlePrevious}
            nextStep={handleNext}
            id={id ? id : selectionId}
            userRole={userRole}
          />
        </>
      )}
      {newCurentStep === 4 && (
        <>
          <StepperComponent step={newCurentStep} />
          <PublishMain
            onPrevious={handlePrevious}
            nextStep={handleNext}
            id={id ? id : selectionId}
          />
        </>
      )}

      <Toaster position="top-right" />
    </>
  );
};

export default ProductOnboardingForm;
